import { React } from 'react';
import Header from "../header";
import { Outlet } from "react-router-dom";
import Footer from '../footer';
import styles from './layout.module.css';

export function Layout() {

    return(
        <div className={styles.layout}>
            <Header />
            <Outlet />
            <Footer />
        </div>
    )
}

export default Layout;